import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  VoicemailJudgmentResultApi,
  VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest,
  GetVoicemailJudgmentResult200Response,
} from '@/api/openapi';

export class VoicemailJudgmentResultApiService extends ApiService {
  api = new VoicemailJudgmentResultApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getVoicemailJudgmentResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest>,
  ): Promise<AxiosResponse<GetVoicemailJudgmentResult200Response>> {
    return this.checkResponse<GetVoicemailJudgmentResult200Response>(
      this.api.getVoicemailJudgmentResult(request, options),
      errorHandlers,
    );
  }
}
